import SearchIcon from '@/shared/assets/icons/search.svg?react'
import { Input } from '@headlessui/react'
import { ChangeEventHandler } from 'react'

type Props = {
  onChange: ChangeEventHandler<HTMLInputElement>
  placeholder?: string
  minWidth?: string
  maxWidth?: string
  className?: string
  value?: string
}

export const SearchInput = ({
  onChange,
  placeholder,
  minWidth = '180px',
  maxWidth = '250px',
  className,
  value,
}: Props) => {
  const baseClasses =
    'rounded-lg py-2 pl-[46px] pr-6 ring ring-card-border dark:ring-card-border-dark placeholder:text-text-secondary w-full'

  return (
    <div className={`relative ${className || ''}`} style={{ minWidth, maxWidth }}>
      <Input
        value={value}
        placeholder={placeholder || 'Поиск'}
        className={`${baseClasses}`}
        onChange={onChange}
      />
      <SearchIcon className="top-[10px] left-4 absolute" />
    </div>
  )
}
